export function resetStateToDefault(state, defaultState, keysToSkip = []) {
  const keysToOverwrite = Object.keys(defaultState).filter((key) => !keysToSkip.includes(key));

  keysToOverwrite.forEach((key) => {
    state[key] = defaultState[key];
  });
}
